import Head from 'next/head';

type JsonLdSchema = Record<string, unknown> | Record<string, unknown>[];

export default function JsonLd({
  schema,
}: {
  schema: JsonLdSchema;
}) {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          // Escape `<`, `>` and `&` so page data (e.g. a tutor's about text)
          // can never break out of the <script> context. JSON.stringify alone
          // does not escape these sequences.
          __html: JSON.stringify(schema)
            .replace(/</g, '\\u003c')
            .replace(/>/g, '\\u003e')
            .replace(/&/g, '\\u0026'),
        }}
      />
    </Head>
  );
}
